import { Injectable } from '@angular/core';
import { LocalStorageService } from '@edassist/common';

interface RefreshLock {
	owner: string;
	expires: number;
}

@Injectable({
  providedIn: 'root',
})
export class RefreshLockService {
  private readonly KEY = 'refreshLock';
  private readonly TTL = 15_000;
  private readonly id = crypto.randomUUID();

  tryLock(): boolean {
    const now = Date.now();

    const cur = LocalStorageService.getItem(this.KEY) as RefreshLock;

    if (!cur || cur?.expires < now) {
			LocalStorageService.setItem(this.KEY, {
				owner: this.id,
				expires: now + this.TTL,
			});

      return LocalStorageService.getItem(this.KEY)?.owner === this.id;
    }

    return false;
  }

  release(): void {
    const cur = LocalStorageService.getItem(this.KEY) ?? {};
    if (cur && cur.owner === this.id) {
			console.debug('Releasing refresh lock', this.id);
			LocalStorageService.removeItem(this.KEY);
    }
  }
}
